import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';

// Import the icon components you already have
import MusicIcon from './icons/MusicIcon';
import FilmIcon from './icons/FilmIcon'; // For Anime
import CertificateIcon from './icons/CertificateIcon';
import EnvelopeIcon from './icons/EnvelopeIcon';
import ContributionsIcon from './icons/ContributionsIcon';

type ProfileType = 'recruiter' | 'developer' | 'stalker' | 'adventure';

// This is the interface that was missing
interface ContinueWatchingProps {
  profile: ProfileType;
}

interface Pick {
  title: string;
  imgSrc: string;
  icon: React.ComponentType<{ style?: React.CSSProperties }>;
  link: string;
}

const continueWatchingConfig: Record<ProfileType, Pick[]> = {
  recruiter: [
    { title: "Music", imgSrc: "https://media.npr.org/assets/img/2023/07/28/gettyimages-155394693-resize-81ac1e68a3fc61fde595c66eef24f72e459d394d.jpg", icon: MusicIcon, link: "/music" },
    { title: "Anime", imgSrc: "https://c4.wallpaperflare.com/wallpaper/1/386/428/bleach-kurosaki-ichigo-final-getsuga-tenshou-mugetsu-1781x1025-anime-bleach-hd-art-wallpaper-preview.jpg", icon: FilmIcon, link: "/Anime" },
    { title: "Contributions", imgSrc: "https://miro.medium.com/v2/resize:fit:1200/1*Ptty86xhJcO6cEgHTNP_sQ.png", icon: ContributionsIcon, link: "/Contributions" },
    { title: "Contact Me", imgSrc: "https://images5.alphacoders.com/320/320927.jpg", icon: EnvelopeIcon, link: "/contact-me" }
  ],
  developer: [
    { title: "Music", imgSrc: "https://cdn.lazyshop.com/files/d2c4f2c8-ada5-455a-86be-728796b838ee/product/2a94a726591be6d1ddb79202468bf11d.jpeg", icon: MusicIcon, link: "/music" },
    { title: "Anime", imgSrc: "https://4kwallpapers.com/images/wallpapers/satoru-gojo-7680x4320-15227.png", icon: FilmIcon, link: "/Anime" },
    { title: "Contributions", imgSrc: "https://images6.alphacoders.com/133/thumb-1920-1330061.jpeg", icon: ContributionsIcon, link: "/Contributions" },
    { title: "Certifications", imgSrc: "https://live.staticflickr.com/8684/16321991324_4f962ec7f3_b.jpg", icon: CertificateIcon, link: "/certifications" },
    { title: "Contact Me", imgSrc: "https://e0.pxfuel.com/wallpapers/613/128/desktop-wallpaper-dark-anime-background-dark-anime-forest.jpg", icon: EnvelopeIcon, link: "/contact-me" }
  ],
  stalker: [
    { title: "Anime", imgSrc: "https://cdn.marvel.com/content/1x/333.jpg", icon: FilmIcon, link: "/Anime" },
    { title: "Contributions", imgSrc: "https://wallpapercat.com/w/full/c/e/1/2175177-3840x2160-desktop-4k-marvel-minimalist-wallpaper-photo.jpg", icon: ContributionsIcon, link: "/Contributions" },
    { title: "Contact Me", imgSrc: "https://images5.alphacoders.com/320/320927.jpg", icon: EnvelopeIcon, link: "/contact-me" }
  ],
  adventure: [
    { title: "Music", imgSrc: "https://wallpapers-clan.com/wp-content/uploads/2025/01/one-piece-monkey-d-luffy-peaceful-sea-desktop-wallpaper-preview.jpg", icon: MusicIcon, link: "/music" },
    { title: "Anime", imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBc9gmZYgx-vnMKy4c86IDDvaBJlTy4nFn7w&s", icon: FilmIcon, link: "/Anime" },
    { title: "Certifications", imgSrc: "https://atlas-content-cdn.pixelsquid.com/stock-images/symbol-coding-gold-logo-AvYKZ25-600.jpg", icon: CertificateIcon, link: "/certifications" },
    { title: "Contact Me", imgSrc: "https://static.wikia.nocookie.net/marvelcinematicuniverse/images/d/de/Avengers_Endgame_International.jpg/revision/latest/scale-to-width-down/1200?cb=20190323034207", icon: EnvelopeIcon, link: "/contact-me" }
  ]
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">Continue Watching for {profile}</h2>
      <div className="card-row">
        {continueWatching.map((pick, index) => {
          const IconComponent = pick.icon; // Assign to a capitalized variable
          return (
            <Link to={pick.link} key={index} className="pick-card">
              <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
              <div className="overlay">
                <div className="pick-label">
                  <IconComponent style={{ marginRight: '8px' }} /> {pick.title}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default ContinueWatching;